import { render, staticRenderFns } from "./zhinengzhizao.vue?vue&type=template&id=f827a978&scoped=true"
import script from "./zhinengzhizao.vue?vue&type=script&lang=js"
export * from "./zhinengzhizao.vue?vue&type=script&lang=js"
import style0 from "./zhinengzhizao.vue?vue&type=style&index=0&id=f827a978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f827a978",
  null
  
)

export default component.exports